/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_OfferingType } from '../models/Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_OfferingType';
import type { Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementResponse } from '../models/Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementResponse';
import type { Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementsResponse } from '../models/Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementsResponse';
import type { Woonstad_Foundation_Portfolio_Api_Models_Response_AdvertisementSearchResponse } from '../models/Woonstad_Foundation_Portfolio_Api_Models_Response_AdvertisementSearchResponse';
import type { Woonstad_Foundation_Portfolio_Api_Models_WRM_GeoJson } from '../models/Woonstad_Foundation_Portfolio_Api_Models_WRM_GeoJson';
import type { Woonstad_Foundation_Portfolio_Api_Models_WRM_TypeCountResponseModel } from '../models/Woonstad_Foundation_Portfolio_Api_Models_WRM_TypeCountResponseModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WoonstadService {

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementsResponse OK
     * @throws ApiError
     */
    public static getOfferingByType20({
offeringType,
qson,
excludeitems,
excludefacets,
size = 10,
}: {
offeringType: Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_OfferingType,
qson?: string,
excludeitems?: boolean,
excludefacets?: boolean,
size?: number,
}): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/woonstad/offering/{offeringType}',
            path: {
                'offeringType': offeringType,
            },
            query: {
                'qson': qson,
                'excludeitems': excludeitems,
                'excludefacets': excludefacets,
                'size': size,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementResponse OK
     * @throws ApiError
     */
    public static getOfferingDetailByUrl20({
url,
}: {
url?: string,
}): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/woonstad/offering/detail',
            query: {
                'url': url,
            },
        });
    }

    /**
     * @deprecated
     * @returns Woonstad_Foundation_Portfolio_Api_Models_Response_AdvertisementSearchResponse OK
     * @throws ApiError
     */
    public static getOfferingByType10({
offeringType,
qson,
excludeitems,
excludefacets,
size = 10,
}: {
offeringType: string,
qson?: string,
excludeitems?: boolean,
excludefacets?: boolean,
size?: number,
}): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Models_Response_AdvertisementSearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/woonstad/offering/{offeringType}',
            path: {
                'offeringType': offeringType,
            },
            query: {
                'qson': qson,
                'excludeitems': excludeitems,
                'excludefacets': excludefacets,
                'size': size,
            },
        });
    }

    /**
     * @deprecated
     * @returns any OK
     * @throws ApiError
     */
    public static getOfferingDetailByUrl10({
url,
}: {
url?: string,
}): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/woonstad/offering/detail',
            query: {
                'url': url,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Models_WRM_GeoJson OK
     * @throws ApiError
     */
    public static getApiWoonstadPoi({
url,
type,
}: {
url?: string,
type?: string,
}): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Models_WRM_GeoJson> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/woonstad/poi',
            query: {
                'url': url,
                'type': type,
            },
        });
    }

    /**
     * @deprecated
     * @returns Woonstad_Foundation_Portfolio_Api_Models_Response_AdvertisementSearchResponse OK
     * @throws ApiError
     */
    public static getApiWoonstadSearchAll({
q,
offerType,
}: {
q?: string,
offerType?: string,
}): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Models_Response_AdvertisementSearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/woonstad/search/all',
            query: {
                'q': q,
                'offerType': offerType,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Models_WRM_TypeCountResponseModel OK
     * @throws ApiError
     */
    public static getApiWoonstadTypecount(): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Models_WRM_TypeCountResponseModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/woonstad/typecount',
        });
    }

}
